import _ from 'lodash';
import moment from 'moment';
import store from '../store';
import { httpNoAuth } from '../utils/axios';
import { createRouter, createWebHistory } from '@ionic/vue-router';
import Matches from '../views/matches/matches.vue'
import Tabs from '../views/tab-layout/index.vue'

const routes = [
  // {
  //   path: '/',
  //   redirect: '/matches'
  // },
  // {
  //   path: '/',
  //   redirect: +process.env.VUE_APP_NATIONAL_ID === 6 ? '/tabs/qr-scanner' : '/tabs/matches',
  // },
  {
    path: '/',
    component: () => import('@/views/home/index.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/tabs/',
    component: Tabs,
    children: [
      {
        path: '',
        redirect: 'matches',
      },
      {
        path: 'matches',
        component: Matches,
      },
      {
        path: 'qr-scanner',
        component: () => import('@/views/qr-scanner/index.vue')
      },
      {
        path: 'venue-checkin',
        component: () => import('@/views/venue-checkin/index.vue')
      },
      {
        path: 'attendee',
        component: () => import('@/views/qr-scanner/index.vue'),
      },
      {
        path: 'teams',
        component: () => import('@/views/teams/index.vue'),
      },
      {
        path: 'incidents',
        component: () => import('@/views/incidents/index.vue'),
      },
      {
        path: 'player-assessment',
        component: () => import('@/views/player-assessment/index.vue'),
      },
      {
        path: 'documents',
        component: () => import('@/views/documents/index.vue')
      },
      {
        path: 'upload',
        component: () => import('@/views/upload/index.vue')
      },
      {
        path: 'event-attendance',
        component: () => import('@/views/event-attendance/attendance-hub.vue')
      },
      {
        path: 'events-attendance',
        component: () => import('@/views/event-attendance/events.vue')
      },
      {
        path: 'account',
        component: () => import('@/views/accounts/account.vue'),
      },
      {
        path: 'settings',
        component: () => import('@/views/settings/settings.vue'),
      },
    ],
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/qr-scanner/verification/:decodedText',
    name: 'qr-scanner.verfication',
    component: () => import('@/views/qr-scanner/verification.vue'),
    meta: {
      requiresAuth: true
    },
  },
  {
    path: '/login',
    component: () => import('@/views/accounts/login.vue')
  },
  {
    path: '/forgot-password',
    component: () => import('@/views/accounts/forgot-password.vue')
  },
  {
    name: 'reset.submit',
    path: '/reset/:token',
    component: () => import('@/views/accounts/reset-password.vue')
  },
  {
    path: '/account',
    name: 'account',
    component: () => import('@/views/accounts/account.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/quick-register',
    name: 'quick-register',
    component: () => import('@/views/quick-register/index.vue'),
    meta: {
      requiresAuth: true
    },
    props: true
  },
  {
    path: '/matches',
    name: 'matches',
    redirect: '/tabs/matches',
    // component: Matches,
    // meta: {
    //   requiresAuth: true
    // }
  },
  {
    path: '/event-attendance',
    name: 'event-attendance',
    redirect: '/tabs/event-attendance',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/venue-checkin',
    name: 'venue-checkin',
    component: () => import('@/views/venue-checkin/index.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/matches/:id',
    name: 'matches.detail',
    component: () => import('@/views/matches/match.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/event-attendance/:id',
    name: 'event-attendance.detail',
    component: () => import('@/views/event-attendance/event.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/teams/:id',
    name: 'teams.detail',
    component: () => import('@/views/teams/team.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/matches/details2',
    name: 'matches.detail2',
    component: () => import('@/views/matches/match-alternative.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/documents',
    name: 'documents',
    redirect: '/tabs/documents',
  },
  {
    path: '/incidents',
    name: 'incidents',
    redirect: '/tabs/incidents',
  },
  {
    path: '/tabs/documents/folders/:id/:name',
    name: 'folders.detail',
    component: () => import('@/views/documents/documents.vue'),
    meta: {
      requiresAuth: true
    },
    props: true
  },
  {
    path: '/tabs/incidents/new',
    name: 'incidents.new',
    component: () => import('@/views/incidents/new.vue'),
    meta: {
      requiresAuth: true
    },
    props: true,
  },
  {
    path: '/tabs/incidents/:id/',
    name: 'incidents.detail',
    component: () => import('@/views/incidents/_id.vue'),
    meta: {
      requiresAuth: true
    },
    props: true
  },
  {
    path: '/tabs/player-assessment/player/:playerId',
    name: 'player-assessment.history',
    component: () => import('@/views/player-assessment/history.vue'),
    meta: {
      requiresAuth: true
    },
    props: true
  },
  {
    path: '/tabs/player-assessment/player/:playerId/new',
    name: 'player-assessment.new',
    component: () => import('@/views/player-assessment/new.vue'),
    meta: {
      requiresAuth: true
    },
    props: true
  },
  {
    path: '/tabs/player-assessment/find/:id',
    name: 'player-assessment.detail',
    component: () => import('@/views/player-assessment/detail.vue'),
    meta: {
      requiresAuth: true
    },
    props: true
  },
  {
    path: '/settings',
    component: () => import('@/views/settings/settings.vue')
  },
  {
    path: '/settings/competition-sort',
    component: () => import('@/views/settings/competition-sort.vue')
  },
  {
    path: '/settings/default-season',
    component: () => import('@/views/settings/default-season.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})


// A "View match in Manager" link from the portal names the official
// (?refereeId=<memberId>). Switch to that member's Referee role so the match
// loads under the role it was assigned to, instead of whatever role was last used.
const selectRefereeRoleFromLink = async (to) => {
  const refereeId = +_.get(to, 'query.refereeId');
  if (!refereeId) return;
  const findRole = () => _.find(store.getters['user/roles'], (r) => r.type === 7 && +_.get(r, 'entity._id') === refereeId);
  if (!findRole()) {
    // referee roles are built client-side; load them if this session has not yet
    await store.dispatch('user/fetchReferee');
    store.commit('user/updateRoles', _.uniqBy(store.getters['user/roles'], '_id'));
  }
  const role = findRole();
  if (role && store.getters['user/activeRoleId'] !== role._id) {
    await store.dispatch('user/updateRole', role._id);
  }
};

// Send a logged-out user to login, then back to the page they asked for
const loginWithReturn = (to) => ({ path: '/login', query: { redirect: to.fullPath } });

router.beforeEach(async (to, from, next) => {
  // Referees cannot re-order competitions — block the screen, not just the link
  if (to.path === '/settings/competition-sort' && store.getters['user/activeRoleType'] === 7) {
    next('/settings');
    return;
  }
  if (to.matched.some((record) => _.get(record, 'meta.requiresAuth') === true)) {
    const now = moment().valueOf();
    const expiry = store.getters['user/expiry'];
    const userId = store.getters['user/userId'];
    const isAuthenticated = store.getters['user/isAuthenticated'];
    const refreshToken = store.getters['user/refreshToken'];
    const verified = store.getters['user/isVerified'];
    const roles = store.getters['user/roles'];

    if (isAuthenticated && expiry - 300 > now) {
      // Valid Token
      if (!verified || roles.length <= 0) {
        // Account not verified, redirect to verify page
        store.commit('user/logout');
        next('/login');
      } else {
        // Account Verified
        await selectRefereeRoleFromLink(to);
        next();
      }
    } else if (expiry - 300 <= now && refreshToken && userId) {
      // Expired Token, refresh token before going to page
      store.commit('loading', true);
      httpNoAuth.post('/assemble/api/v1/account/manager/authorize',
        {
          refresh_token: refreshToken,
          user_id: userId,
        })
        .then(async (response) => {
          // Refresh Successful - Login User
          store.commit('user/login', response.data);
          store.dispatch('national/setup');
          await store.dispatch('user/fetchReferee');
          store.dispatch('user/fetchUserData');
          await selectRefereeRoleFromLink(to);
          next();
        })
        .catch(() => {
          // Failed Refresh - Logout User
          store.commit('user/logout');
          next(loginWithReturn(to));
        });
    } else {
      // No Data - Redirect to Login
      store.commit('user/logout');
      next(loginWithReturn(to));
    }
  } else {
    next();
  }
});

export default router
